import { useState } from 'react'
import { OB } from './OB'
import { EquipItem } from './EquipItem'
import { Protection } from './Protection'

export const PlayItYourWay = () => {
    const [activeSubSystem, setActiveSubSystem] = useState('protection')
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    const PlayItYourWayNav = () => {
        return (
            <nav className='mx-auto my-8'>
                <ul className='[&>li>img]:mx-auto [&>li>img]:w-full [&>li]:w-[47%] [&>li]:md:w-[22%] cursor-pointer flex justify-center gap-4 flex-wrap mx-auto items-end px-4 md:px-0 max-w-[1200px]'>
                    <li>
                        <span className='relative inline-block'>
                            {' '}
                            <img
                                onClick={() => {
                                    scrollToTop()
                                    setActiveSubSystem('protection')
                                }}
                                className={` ${
                                    activeSubSystem === 'protection' && 'brightness-125'
                                }  mx-auto hover:brightness-125 duration-300`}
                                alt='protection'
                                src={`${process.env.PUBLIC_URL}/images/system/header-protection-system.webp`}
                            />
                        </span>
                    </li>
                    <li>
                        {' '}
                        <span className='relative inline-block'>
                            <img
                                onClick={() => {
                                    scrollToTop()
                                    setActiveSubSystem('ob')
                                }}
                                className={` ${
                                    activeSubSystem === 'ob' && 'brightness-125'
                                }  hover:brightness-125 duration-300`}
                                alt='ob'
                                src={`${process.env.PUBLIC_URL}/images/system/header-ob-system.webp`}
                            />
                        </span>
                    </li>
                    <li>
                        <span className='relative inline-block'>
                            <img
                                onClick={() => {
                                    scrollToTop()
                                    setActiveSubSystem('equipitem')
                                }}
                                className={` ${
                                    activeSubSystem === 'equipitem' && 'brightness-125'
                                }  hover:brightness-125 duration-300`}
                                alt='equipitem'
                                src={`${process.env.PUBLIC_URL}/images/system/header-equip-system.webp`}
                            />
                        </span>
                    </li>
                </ul>
            </nav>
        )
    }
    return (
        <>
            <PlayItYourWayNav />
            <div className='max-w-[1200px] mx-auto my-12 md:my-20'>
                {(() => {
                    switch (activeSubSystem) {
                        case 'protection':
                            return <Protection />
                        case 'equipitem':
                            return <EquipItem />
                        case 'ob':
                            return <OB />

                        default:
                            return null
                    }
                })()}
            </div>{' '}
            <PlayItYourWayNav />
        </>
    )
}
